// Fliksymbolen följer vyn, så att MötesMaskinen och Kommunkartan går att skilja åt bland flikarna (Alex 2026-10-12).
// MötesMaskinen (version 3 med ?ui=v3, eller Mötesbokning med ?vy=motesbokning) får loggan i grönt med kalender,
// kartan får loggan i rött med kartnål. Filerna ligger i public/ikon-<mm|kk>-<16|32|180>.png.

/** 'mm' för MötesMaskinen, 'kk' för Kommunkartan. */
export function systemFor(location, motesbokning) {
  try {
    const q = new URLSearchParams(location.search);
    const ui = q.get('ui');
    if (ui === 'v3' || ui === 'v2') return 'mm';
    if (motesbokning ?? (q.get('vy') === 'motesbokning')) return 'mm';
  } catch { /* faller till kartan */ }
  return 'kk';
}

/** Byter favicon och apple-touch-icon i <head> till systemets symbol. */
export function setFliksymbol(system, doc = document) {
  const bas = process.env.PUBLIC_URL || '';
  doc.querySelectorAll('link[rel="icon"][sizes], link[rel="apple-touch-icon"]').forEach((l) => {
    const storlek = l.rel === 'apple-touch-icon' ? '180' : (l.getAttribute('sizes') || '').split('x')[0];
    if (['16', '32', '180'].includes(storlek)) l.href = `${bas}/ikon-${system}-${storlek}.png`;
  });
}
